import {
  useQuery,
} from 'react-query';

import { useMiddleman } from '@hubins/middleman';

export const usePortfolioFiles = (portfolioUuid: string, tags: string[] = []) => {
  const middleman = useMiddleman();
  return useQuery(['portfolioFiles', portfolioUuid, tags], () => {
    return middleman.get(`/portfolio/files/${portfolioUuid}${tags.length > 0 ? `?tags=${tags.join(',')}` : ''}`).then(response => response.data);
  }, {
    enabled: !!portfolioUuid,
  });
};